exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".minto-arrow-tooltip{position:relative;display:inline-block}.minto-arrow-tooltip__text{visibility:hidden;background-color:#fff;color:#050e61;border-radius:6px;padding:10px;position:absolute;z-index:1;min-width:300px;top:30px}.minto-arrow-tooltip:hover .minto-arrow-tooltip__text{visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/arrow-tooltip/arrow-tooltip.scss
// module id = 895
// module chunks = 0